import { logType, useJourney } from "../utils/common";
import { buildIdentityLogEntry } from "../utils/identityLog";

/**
 * Writes one IDENTITY log row per answered face-verification API call.
 *
 * Only ever used on the RECORDER — it is the sole writer of these rows, for the
 * calls it makes itself and for the ones it delegated to the client (which come
 * back over IDENTITY_RESULT). Keeping a single writer means the journey's call
 * log has one clock and one ordering, and the client never needs journey
 * credentials for logging.
 *
 * Fire-and-forget by design: a failed log write must never disturb the
 * verification pipeline, so nothing here is awaited and logJourney swallows its
 * own errors. Roughly 50 rows per journey, spread over the 5s pipeline tick.
 */
export default function useIdentityLog() {
  const { logJourney } = useJourney();

  return function logIdentityCall({
    apiName,
    body,
    page,
    executedBy,
    delegated,
  }) {
    const entry = buildIdentityLogEntry({
      apiName,
      body,
      page,
      executedBy,
      delegated,
    });
    // null means there was nothing truthful to record (no body, unknown api).
    // Writing a placeholder would corrupt the call count these rows represent.
    if (!entry) return;

    logJourney({
      type: logType.IDENTITY,
      message: entry.message,
      metadata: entry.metadata,
    });
  };
}
